import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Button,
  Combobox,
  ComboboxItem,
  Box as WalletsHeader,
} from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { MerchantType } from 'types/types'
import track from 'utils/tracker'

type LatestMerchantsProps = {
  merchants: MerchantType[]
  selectedId: string
  onSelectMerchant: (MerchantType) => void
}

const LatestMerchants = ({ merchants, selectedId, onSelectMerchant }: LatestMerchantsProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const merchantOptions = merchants?.map<ComboboxItem>(
    ({
      merchantId,
      wallet: {
        id: walletId,
        balance,
        description,
        currency: { code: currencyCode },
      },
      displayName,
    }) => {
      return {
        LeftElement: <Avatar size="small" name={currencyCode?.toLowerCase()} />,
        leftText: `${displayName} ...${merchantId?.slice(-8)}`,
        rightText: `${balance} ${currencyCode} (${description})`,
        value: walletId.toString(),
      }
    }
  )

  return (
    <>
      <WalletsHeader flex justify="between" align="center">
        <p className="text-body-regular text-foreground-subdued">
          {t('latestMerchants.description')}
        </p>
        <Button
          onClick={() => {
            track.Hotjar.event('user_clicked_dashboard_view_all_merchants')
            track.GA.event({
              category: 'Dashboard',
              action: 'click',
              label: 'Button: View all merchants',
            })

            navigate(`${PathNames.SETTINGS}${PathNames.MANAGE_MERCHANT_DETAILS}`)
          }}
        >
          {t('latestMerchants.viewAll')}
        </Button>
      </WalletsHeader>
      <Combobox
        items={merchantOptions}
        id="latest-merchants"
        defaultValue={selectedId}
        onChange={value => onSelectMerchant(value)}
      />
    </>
  )
}

export default LatestMerchants
